import React from 'react';
import ReactDOM from 'react-dom/client';
import  { GlobalStyle } from './styles/global/Global.styled';
import StyledSelect from './styles/global/Select.styled';
import StyledButton from './styles/global/Button.styled';
import './i18n';
import NovaVideowall from './NovaVideowall';

console.log('Hello, world!');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <GlobalStyle />
    <StyledButton/>
    <StyledSelect />
    <NovaVideowall />
  </>
);
